export enum ETypeQuestion {
  DROPDOWN = 'DROPDOWN',
  TEXTBOX = 'TEXTBOX',
  CHECKBOXLIST = 'CHECKBOXLIST',
  EMAIL = 'EMAIL',
  CHECKBOX = 'CHECKBOX',
  RATING = 'RATING',
  DATE = 'DATE',
}
